"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var _types_1 = require("../../types");
exports.default = (_a = {},
    _a[_types_1.Network.goerli] = {
        POOL_FACTORY: '0x1D7021Eb657b9ca82D41edc5AC963aAE153F5AdF',
    },
    _a);
